import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { environment } from "../../../environments/environment";
import { OutpassPrintDataModel, DocumentCode, ActiveDocumentVersionVm } from 'shared/models';
import { CompanyInfo } from "shared/models";

// ✅ REMOVED: Old interfaces - now using backend models

import { DocumentService } from 'shared/core';
import { sentByText } from '../components/outpass-sent-by-display';

@Component({
    selector: "app-outpassprint",
    templateUrl: "./outpassprint.component.html",
    styleUrls: ["./outpassprint.component.css"],
    standalone: false
})
export class OutPassPrintComponent implements OnInit {
  ApiUrl = environment.Api_Url;
  OutpassId = 0;
  count: number = 0;
  PrintAllowed: boolean = false;
  Company = {
    CompanyName: '',
    HeadOfficeAddress: '',
    FactoryAddress: ''
  };

  // ✅ NEW: Use backend-processed print data
  printData: OutpassPrintDataModel = new OutpassPrintDataModel();
  loading: boolean = false;
  sentByDisplay: string = '';

  constructor(public http: HttpClient, private route: ActivatedRoute, private documentService: DocumentService) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.OutpassId = params['id'];
    });
    this.Company.CompanyName = CompanyInfo.CompanyName;
    this.Company.HeadOfficeAddress = CompanyInfo.HeadOfficAddress;
    this.Company.FactoryAddress = CompanyInfo.FactoryAddress;
    this.Company.FactoryAddress = CompanyInfo.FactoryAddress;
    this.GetDocumentVersion();
    this.GetOutPassPrintData(this.OutpassId);
  }

  ActiveDocumentVersion: ActiveDocumentVersionVm;

  GetDocumentVersion() {
    this.documentService.getActiveVersionByCode(DocumentCode.OutPass).subscribe(res => {
      this.ActiveDocumentVersion = res;
    });
  }

  // ✅ NEW: Use backend endpoint for consolidated print data
  GetOutPassPrintData(outpassId: number) {
    this.loading = true;
    let url = this.ApiUrl + 'outpass/getoutpassprintdata?outpassid=' + outpassId;
    this.http.get<OutpassPrintDataModel>(url).subscribe(
      (res) => {
        this.printData = res;
        this.sentByDisplay = sentByText(res.OutpassDetails);
        this.PrintAllowed = ['Approved', 'Approval Pending', 'Gate Out Completed'].includes(this.printData.OutpassDetails.Status);
        this.loading = false;

        // Auto-print after data loads
        setTimeout(() => {
          window.print();
          window.onafterprint = () => {
            window.close();
          };
        }, 100);
      },
      (error) => {
        this.loading = false;
        this.count++;
        if (this.count < 2) {
          this.GetOutPassPrintData(outpassId);
        }
        console.error('Error loading OutPass print data:', error);
      }
    );
  }

  // ✅ REMOVED: Old method - replaced with GetOutPassPrintData

  // ✅ REMOVED: Complex grouping logic - now handled by backend

  // ✅ REMOVED: All old methods - data now comes pre-processed from backend
}
